module.exports = __webpack_public_path__ + "img/芫花.9b3e8b68.jpg";